import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";
import { NIL } from "uuid";

////////////////////////////////////////////////////////////////////////////

type Props = Omit<IAutoCompleteProps, 'onGetSuggestions' | "emptyThumbnail">;

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de publicações
 * @param props
 */
export const UserListsAutoComplete: React.FC<Props> = (props) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.knowledgePublication.getUserLists({
                searchText: searchText,
                pageNumber: pageNumber,
                pageSize: pageSize,
                publicationId: NIL,
                publicListsOnly: true
            }, { signal })
                .then(result => {
                    resolve({
                        items: result.data.items.map(i => ({ key: i.listId, label: i.name } as AutoCompleteDataModel)),
                        totalRows: result.data.totalRows
                    });
                })
                .catch(error => {
                    if (!isCanceledError(error)) {
                        resolve({ items: [], totalRows: 0 });
                        if (props.onError) props.onError(props.error);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onGetSuggestions={getSuggestions}
        />
    );
};
